import { SubmitHandler, useForm } from "react-hook-form";
import { Col, Form, Input, Label, Modal, ModalBody, Row } from "reactstrap";
import { Btn, H5 } from "../../../../AbstractElements";
import { AddBookmark, Cancel, Collection, Description, Group, Save, Title, WebUrl } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { addNewBookmark, setAddModal, setBookmarkValidation } from "../../../../ReduxToolkit/Reducers/BookmarkTabSlice";
import { AddNewBookMarkInterFace } from "../../../../Types/BookmarkType";

const BookmarkModal = () => {
  const { addModal, bookmarkValidation } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const addToggle = () => dispatch(setAddModal());
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AddNewBookMarkInterFace>();

  const onSubmit: SubmitHandler<AddNewBookMarkInterFace> = (data) => {
    dispatch(addNewBookmark(data));
    dispatch(setBookmarkValidation(false));
    dispatch(setAddModal());
    reset();
  };

  return (
    <Modal isOpen={addModal} toggle={addToggle} size="lg" className="modal-bookmark">
      <div className="modal-header">
        <H5 className="modal-title">{AddBookmark}</H5>
        <Btn close color="transparent" onClick={addToggle}></Btn>
      </div>
      <ModalBody>
        <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md="12" className="mb-3 mt-0">
              <Label>{WebUrl}</Label>
              <input className={`form-control ${bookmarkValidation && `${errors.url ? "is-invalid" : "is-valid"}`}`} type="text" {...register("url", { required: true })} autoComplete="off" />
            </Col>
            <Col md="12" className="mb-3 mt-0">
              <Label>{Title}</Label>
              <input className={`form-control ${bookmarkValidation && `${errors.title ? "is-invalid" : "is-valid"}`}`} type="text" {...register("title", { required: true })} autoComplete="off" />
            </Col>
            <Col md="12" className="mb-3 mt-0">
              <Label>{Description}</Label>
              <input className={`form-control ${bookmarkValidation && `${errors.desc ? "is-invalid" : "is-valid"}`}`} type="textarea" {...register("desc", { required: true })} autoComplete="off" />
            </Col>
            <Col md="6" className="mb-3 mt-0">
              <Label>{Group}</Label>
              <Input type="select" name="group" className="js-example-basic-single">
                <option value="My Bookmark">My Bookmarks</option>
              </Input>
            </Col>
            <Col md="6" className="mb-3 mt-0">
              <Label>{Collection}</Label>
              <Input type="select" name="collection" className="js-example-disabled-results">
                <option value="General">General</option>
                <option value="Fs">Fs</option>
              </Input>
            </Col>
          </Row>
          <Btn color="secondary" className="me-1" type="submit" onClick={() => dispatch(setBookmarkValidation(true))}>{Save}</Btn>
          <Btn color="primary" onClick={addToggle}>{Cancel}</Btn>
        </Form>
      </ModalBody>
    </Modal>
  );
};
export default BookmarkModal;
